import { gsap } from 'gsap';
import { SplitText } from 'gsap/SplitText';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
gsap.registerPlugin(ScrollTrigger, SplitText);

export const hoverTextModule = () => {

    const hoverTextWrappers = document.querySelectorAll('.js-hover-text-wrapper');

    hoverTextWrappers.forEach(hoverTextWrapper => {

        const hoverText = hoverTextWrapper.querySelector('.js-hover-text');

        ScrollTrigger.matchMedia({
            "(pointer: fine)": function() {

                const splitText = new SplitText(hoverText, {
                    type: "chars, words, lines",
                    reduceWhiteSpace: false,

                });

                let chars = [];

                splitText.chars.forEach(char => {

                    const wrapper = document.createElement('div');
                    const inner = document.createElement('div');

                    inner.classList.add('inline-flex', 'flex-col', 'relative');
                    wrapper.classList.add('inline-flex', 'relative', 'overflow-hidden');

                    wrapper.appendChild(inner);

                    char.parentNode.insertBefore(wrapper, char);

                    inner.appendChild(char);
                    inner.appendChild(char.cloneNode(true));

                    // get last element inside inner
                    const lastElement = inner.lastElementChild;
                    lastElement.classList.add('absolute!', 'bottom-0', 'left-0', 'translate-y-full');

                    chars.push(inner);

                });

                hoverTextWrapper.addEventListener('mouseenter', () => {

                    const tl = gsap.timeline();

                    tl.to(chars, {
                        yPercent: -100,
                        ease: "power4.out",
                        duration: 0.4,
                        stagger: {
                            amount: 0.1,
                        }
                    })
                    .to(chars, {
                        yPercent: 0,
                        duration: 0,
                    });

                });

            }
        });


    });

}

export default hoverTextModule;